export class ResetarSenhaRequest {
  token: string;
  novaSenha: string;
}
